<template>
    <v-form v-model="formValido" ref="formInterno">
        <div :key="componentKey">
            <div class="d-flex">
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            :rules="[v => !!v || 'CNPJ é obrigatório']" 
                            clearable outlined label="CNPJ" v-model="objNf.cnpj" @blur="getCnpjInfo(objNf.cnpj)" 
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="8">
                        <v-text-field 
                            :rules="[
                                v => !!v || 'E-mail é obrigatório',
                                v => /.+@.+\..+/.test(v) || 'E-mail inválido'
                            ]"
                            clearable outlined label="Email" v-model="objNf.email" />
                    </v-col>
                </v-row>
            </div>

            <div>
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.cep"
                            clearable
                            outlined
                            label="CEP"
                            :rules="[v => !!v || 'CEP é obrigatório',]"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.cidade"
                            clearable
                            outlined
                            label="Cidade"
                            :rules="[v => !!v || 'Cidade é obrigatório',]"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.codigoCidade"
                            clearable
                            outlined
                            label="Código da Cidade"
                            :rules="[v => !!v || 'Código é obrigatório']" 
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.logradouro"
                            clearable
                            outlined
                            label="Logradouro"
                            :rules="[v => !!v || 'Logradouro é obrigatório',]"
                        />
                    </v-col>
                    
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.bairro"
                            clearable
                            outlined
                            label="Bairro"
                            :rules="[v => !!v || 'Bairro é obrigatório',]"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.numero"
                            clearable
                            outlined
                            label="Número"
                        />
                    </v-col>

                </v-row>
            </div>

            <div>
                <v-row>

                    <v-col cols="12" sm="6" md="10">
                        <v-text-field
                            v-model="objNf.complemento"
                            clearable
                            outlined
                            label="Complemento"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="2">
                        <v-text-field 
                            :rules="[v => !!v || 'UF é obrigatório']"  
                            clearable outlined 
                            label="UF" 
                            v-model="objNf.uf" 
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-combobox 
                            label="Condições de Pagamento" 
                            v-model="objNf.condPag" 
                            :items="['á vista', 'á prazo']" 
                            outlined
                            clearable
                        ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-combobox 
                            label="Meio de Pagamento" 
                            v-model="objNf.meioPagamento" 
                            :items="meioPagamentoOptions" 
                            outlined
                            clearable
                        ></v-combobox>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-autocomplete 
                            v-model="objNf.cfop"
                            :items="cfops" 
                            item-text="codigo"
                            item-value="codigo" 
                            label="CFOP" 
                            dense 
                            outlined
                            @change="selectedCfop"
                        >
                            <template v-slot:item="{ item }">
                                <div class="d-flex flex-column">
                                    <div class="font-weight-bold">{{ item.codigo }}</div>
                                    <div>{{ item.descricao }}</div>
                                </div>
                            </template>
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            clearable 
                            outlined 
                            label="Natureza de Operação" 
                            v-model="objNf.naturezaOp" 
                            readonly
                            :key="componentKey"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-combobox 
                            v-model="objNf.operacaoFiscal"
                            :items="operacaoFiscalOptions" 
                            label="Operação Fiscal" 
                            dense 
                            outlined
                            readonly
                        ></v-combobox>
                    </v-col>

                    <!-- <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            type="date" 
                            clearable 
                            outlined 
                            
                            label="Data de Entrada/Saída" 
                            v-model="objNf.dataSaida" 
                        />
                    </v-col> -->

                    <v-col cols="12" sm="6" md="4" v-if="isNfRemessa">
                        <v-text-field
                            clearable
                            outlined
                            label="Código Benefício Fiscal"
                            v-model="objNf.codigoBeneficioFiscal"
                        />
                    </v-col>
                </v-row>

            </div>

        </div>

        <div class="d-flex align-center">
            <v-checkbox v-model="objNf.addRetirada" />
            <label>Adicionar Informações de Retirada/Entrega</label>
        </div>
        
        <v-card>
            <v-card-title>
                Romaneios
            </v-card-title>
            <v-autocomplete 
                v-model="objNf.romaneio" 
                :items="romaneios" 
                :item-text="romaneioItemText"
                item-value="_id" 
                :item-disabled="romaneioIndisponivel"
                label="Romaneio" 
                dense 
                chips
                outlined 
                multiple
                return-object
            >
                <template v-slot:item="{ item, on, attrs }">
                    <div class="w-100" @click="alertarRomaneioIndisponivel(item)">
                        <v-list-item
                            v-bind="attrs"
                            v-on="romaneioIndisponivel(item) ? {} : on"
                            :disabled="romaneioIndisponivel(item)"
                        >
                            <v-list-item-content>
                                <v-list-item-title>{{ romaneioItemText(item) }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon v-if="romaneioIndisponivel(item)">
                                <v-icon color="warning">mdi-alert-circle-outline</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </div>
                </template>
            </v-autocomplete>
        </v-card>
            

        <div class="mb-5 mt-5" v-if="objNf.condPag == 'á prazo'" key="componentKey">
            <v-card>
                <v-card-title>
                    Parcelas - {{ sumParcelas()?.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' }) }}
                </v-card-title>
                <v-row class="mb-3" style="gap: 16px;">
                    <v-col cols="12" sm="6" md="4">
                        <v-card color="#e3f2fd" class="pa-3" outlined>
                            <div class="font-weight-bold">Valor Nota</div>
                            <div style="font-size: 1.2em; color: #1976d2;">
                                {{ valorNotaFormatado }}
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-card color="#e8f5e9" class="pa-3" outlined>
                            <div class="font-weight-bold">Total com Impostos</div>
                            <div style="font-size: 1.2em; color: #388e3c;">
                                {{ totalComImpostosFormatado }}
                            </div>
                        </v-card>
                    </v-col>
                </v-row>

                <div>
                <v-row dense v-for="parcela in parcelas" :key="parcela.numParcela">
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="N° Parcela" v-model="parcela.numParcela" />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="Data de Vencimento" type="date" v-model="parcela.vencimento" />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            :key="`parcela-${totalComImpostosInCents()}-${parcelas.length}`"
                            :rules="[
                                () => validarTotalParcelas()
                            ]"
                            clearable outlined label="Valor da Parcela" 
                            v-money="money" 
                            v-model="parcela.vrlParcela" 
                        />
                    </v-col>

                    <!-- Botão com ícone ao final -->
                    <v-col cols="12" sm="6" md="4" >
                        <v-btn color="primary" icon @click="addParcela()" v-if="podeAdicionarParcela()">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn color="error" icon @click="removeParcela(parcela)" v-if="parcelas.length >= 2">
                            <v-icon>mdi-minus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                </div>

            </v-card>
        </div>

        <v-card class="mb-5 mt-5">
            <v-card-title>
                Itens de Nota Fiscal
            </v-card-title>

            <TableItensNotaFiscal 
                :addItem="false"
                :readyall="true"
                :schemaName="'FisPreDocEmiItem'"
                :itemsByRomaneio="temRomaneio ? osItems : []"
                :open="openItem"
                :jobSelected="jobSelected"
                :isNfRemessa="isNfRemessa"
                :isNfReferenciada="isNfReferenciada"
                :isDuplicating="isDuplicating"
                relation
                :ids="temRomaneio ? objNf.itens : []"
                :item="temRomaneio ? arrayItems : []"
                @save-item="
                ($event) => {
                    this.arrayItems = [...$event];
                    this.sumItems();
                }"
                @update-total-com-impostos="totImpostos"
            />
        </v-card>

        <v-card class="mt-5">
            <v-card-title bold>
                Transportadora
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete 
                            v-model="objNf.transportadora" 
                            :items="transportadoras" 
                            item-text="razaoSocial"
                            item-value="id" 
                            label="Transpostadora" 
                            dense 
                            outlined 
                        >
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.quantidade" label="Quantidade" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.especie" label="Especie" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.marca" label="Marca" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.numeracao" label="Numeração" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.pesoBruto" label="Peso Bruto KG" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.pesoLiquido" label="Peso Liquido KG" outlined />
                    </v-col>

                </v-row>
            </v-card-text>
        </v-card>

        <v-card class="mt-5">
            <v-card-title bold>
                Informações Adicionais
            </v-card-title>
            <v-card-text>
                <v-textarea
                    v-model="objNf.informacaoAdd"
                    label="Informação Adionais"
                    outlined
                ></v-textarea>
            </v-card-text>
        </v-card>

        <v-expansion-panels multiple>
        </v-expansion-panels>
        
    </v-form>
</template>

<script>
import {VMoney} from 'v-money'
import Vue from 'vue';
import TableItensNotaFiscal from './TableItensNotaFiscal.vue';
export default {
    name: 'NotaFiscal',
    directives: { money: VMoney },
    props: ['projects', 'userInfo', 'item', 'pacelasCads', 'valorNota', 'jobSelected', 'romaneios', 'isNfRemessa', 'isNfReferenciada', 'isDuplicating'],
    components: {
        TableItensNotaFiscal,
        //CreateItensNotaFiscalView: () => import('./CreateItensNotaFiscalView.vue')
    },
    data(){
        return {
            expasionInfoGerais: false,
            salesOrders: [],
            openItem: false,
            arrayItems: [],
            componentKey: 0,
            formValido: false,
            searchNotaChaveAcesso: '',
            osItems: [],
            transportadoras: [],
            cfops: [],
            // Removido o flag, vamos garantir atualização reativa
            operacaoFiscalOptions: ["Entrada", "Saída"],
            meioPagamentoOptions: [
                "Dinheiro",
                "Cheque",
                "Cartão de Crédito",
                "Cartão de Débito",
                "Cartão da Loja",
                "Vale Alimentação",
                "Vale Refeição",
                "Vale Presente",
                "Vale Combustível",
                "Boleto Bancário",
                "Depósito Bancário",
                "Pagamento Instantâneo (PIX) - Dinâmico",
                "Transferência bancária, Carteira Digital",
                "Programa de fidelidade, Cashback, Crédito Virtual",
                "Pagamento Instantâneo (PIX) - Estático",
                "Crédito em Loja",
                "Pagamento Eletrônico não Informado - falha de hardware do sistema emissor",
                "Sem pagamento",
                "Pagamento Posterior",
                "Outros"
            ],
            money: {
                locale: "pt-br",
                decimal: '.',
                thousands: '.',
                prefix: '',
                precision: 2,
                masked: false
            },
            parcelas: this.pacelasCads.length > 0 ?  this.pacelasCads : [
                { numParcela: '01', vencimento: null, vrlParcela: 0 }
            ],
            itemsData: [],
            objNf: {
                nomeDestinatario: null,
                dataSaida: new Date().toISOString().split('T')[0],
                cep: '',
                cidade: '',
                codigoCidade: '',
                logradouro: '',
                bairro: '',
                numero: '',
                complemento: '',
                status: '',
                naturezaOp: null,
                cnpj: null,
                uf: '',
                meioPagamento: '',
                defFiscais: null,
                ncm: null,
                cest: null,
                cfop: null,
                valorUnitario: 0,
                quantidade: 0,
                icms: null,
                baseIcms: null,
                valueIcms: null,
                condPag: '',
                job: '',
                os: '',
                romaneio: [],
                email: '',
                itens: [],
                notaFiscalMae: '',
                addRetirada: false,
                transportadora: '',
                pesoBruto: null,
                pesoLiquido: null,
                especie: null,
                marca: null,
                numeracao: null,
                valorFrete: 0,
                valorSeguro: 0,
                valorDesconto: 0,
                valorOutros: 0,
                informacaoAdd: '',
                codigoBeneficioFiscal: ''
            }
        }
    },
    computed: {
        temRomaneio() {
            return Array.isArray(this.objNf?.romaneio) && this.objNf.romaneio.length > 0
        },

        valorNotaCalculado() {
            return this.normalizeMoneyValue(this.valorNota);
        },

        valorNotaFormatado() {
            return this.valorNotaCalculado.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' });
        },

        totalComImpostos() {
            return this.calcularTotalComImpostos();
        },
                // atualizarTotalComImpostos() {
                //     // Força atualização do total com impostos
                //     this.componentKey += 1;
                // },
        totalComImpostosFormatado() {
            return this.totalComImpostos.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' });
        }
    },
    methods: {
        normalizeMoneyValue(value) {
            if (value == null || value === '') return 0;

            if (typeof value === 'number') {
                return Number.isFinite(value) ? value / 100 : 0;
            }

            const sanitizedValue = String(value)
                .trim()
                .replace(/\s/g, '')
                .replace(/[^\d,.-]/g, '');

            if (!sanitizedValue) return 0;

            const lastCommaIndex = sanitizedValue.lastIndexOf(',');
            const lastDotIndex = sanitizedValue.lastIndexOf('.');
            const separatorIndex = Math.max(lastCommaIndex, lastDotIndex);

            if (separatorIndex === -1) {
                const integerValue = Number(sanitizedValue.replace(/[.,]/g, ''));
                return Number.isFinite(integerValue) ? integerValue / 100 : 0;
            }

            const integerPart = sanitizedValue.slice(0, separatorIndex).replace(/[.,]/g, '');
            const decimalPart = sanitizedValue.slice(separatorIndex + 1).replace(/[.,]/g, '');
            const normalizedValue = `${integerPart || '0'}.${decimalPart || '0'}`;
            const numericValue = Number(normalizedValue);

            return Number.isFinite(numericValue) ? numericValue : 0;
        },

        calcularTotalComImpostos() {
            let total = this.valorNotaCalculado;

            if (this.arrayItems && this.arrayItems.length > 0) {
                this.arrayItems.forEach((item) => {
                    total += this.normalizeMoneyValue(item.ipiValor);
                    total += this.normalizeMoneyValue(item.valorFrete);
                    total += this.normalizeMoneyValue(item.valorSeguro);
                    total -= this.normalizeMoneyValue(item.valorDesconto);
                    total += this.normalizeMoneyValue(item.valorOutros);
                });
            }

            return total;
        },

        totImpostos () {
            const total = this.calcularTotalComImpostos();

            this.componentKey += 1; // Força atualização do componente para refletir o novo total
            return total;
        },
        async getDataEntity(schemaName){
            const response = await Vue.prototype.$http.get(`/Entity/${schemaName}`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            });

            return response.data.data.data
        },

        addParcela(){
            this.parcelas.push({ 
                numParcela: String(this.parcelas.length + 1).padStart(2, '0'), 
                vencimento: null, 
                vrlParcela: 0 
            })  
        },

        async removeParcela(parcela){
            this.parcelas =  this.parcelas.filter((p) => p.numParcela != parcela.numParcela)

            if(parcela.id){
                await Vue.prototype.$http.delete(`/Entity/FisPreDocEmiFin?id=${parcela.id}`)
            }

        },

        sumParcelas(){
            let sum = 0
            this.parcelas?.map((p) => {
                if (p.vrlParcela) sum += this.normalizeMoneyValue(p.vrlParcela)
            })

            return sum || 0
        },

        toMoneyCentsFromReais(value) {
            return Math.round((Number(value || 0) + Number.EPSILON) * 100)
        },

        sumParcelasInCents() {
            return this.toMoneyCentsFromReais(this.sumParcelas())
        },

        totalComImpostosInCents() {
            return this.toMoneyCentsFromReais(this.totalComImpostos)
        },

        podeAdicionarParcela() {
            return this.sumParcelasInCents() <= this.totalComImpostosInCents()
        },

        validarTotalParcelas() {
            return this.sumParcelasInCents() <= this.totalComImpostosInCents()
                || `A soma das parcelas não pode ultrapassar o total (${this.totalComImpostosFormatado})`;
        },

        async getCnpjInfo(value){

            if(value?.length == 18){
                const response = await Vue.prototype.$http.post('/Action/run', 
                    { 
                        actionId: "128f5633-f624-41f8-abcf-043bc39a4bb7",
                        actionName: "Action info CNPJ",
                        params: { 
                            cnpj: value.replace(/\D/g, '')
                        } 
                    })


                if(response.data.data.data.status == "ERROR"){
                    this.$notfy.error("CNPJ invalido.");
                    // this.objNf.cpfOrCnpjEmitente = ''
                    return
                }

                const info = response.data.data.data

                this.objNf.uf = info.uf
                this.objNf.email = info.email

                this.objNf.bairro = info.bairro
                this.objNf.cidade = info.municipio
                this.objNf.logradouro = info.logradouro
                this.objNf.numero = info.numero
                this.objNf.cep = info.cep
                this.objNf.complemento = info.complemento

                this.componentKey += 1
            }
        },

        parseMoeda(valor) {
            if (!valor) return 0;

            valor = valor.toString().trim();

            // Caso especial: "395.039.30" -> "395039,30"
            const partes = valor.split(".");
            if (partes.length > 2 && !valor.includes(",")) {
                const decimal = partes.pop(); // pega o último como decimal
                valor = partes.join("") + "," + decimal; 
            }

            return parseFloat(
                valor.replace(/\./g, "")   // remove milhar
                    ?.replace(",", ".")    // vírgula -> ponto decimal
            ) || 0;
        },

        sumItems(){
            let sum = 0
            this.arrayItems?.map((item) => {
                console.log('valor total >>> ', item.valorTotal, this.parseMoeda(item.valorTotal))
                sum += Number(String(item.valorTotal)?.replace(/\./g, '')?.replace(',', '') || 0)
            })
            //console.log('sum itens ', sum)
            this.$emit('sumItens', sum)
        },

        getFisTipiOptions () {
            Vue.prototype.$http.get(`/Entity/FisTipi`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.fisTipiOptions = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching FisTipi options:", error);
            });
        },

        getOperacaoFiscalOptions () {
            Vue.prototype.$http.get(`/Entity/FisOper`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.operacaoFiscalOptions = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching Operacao Fiscal options:", error);
            });
        },

        getCFOPs(){
            Vue.prototype.$http.get(`/Entity/CFOP/search-fields`, {
                params: {
                    page: 1,
                    limit: 9999,
                    searchFields: '[codigo]',
                    value: this.isNfRemessa ? '[5901,6901,5905,6905,5912,6912,5910,6910,5949]' : undefined
                }
            }).then(response => {
                this.cfops = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching cfops options:", error);
            });
        },
        
        selectedCfop(value){
            const cfopSelected = this.cfops.filter((cfop) => cfop.codigo == value)[0] || []

            this.objNf.naturezaOp = cfopSelected?.descricao || ''
            this.objNf.operacaoFiscal = cfopSelected.operacaoFiscal

            this.componentKey += 1
        },

        getRelationId(value) {
            if (Array.isArray(value)) return this.getRelationId(value[0])
            if (value && typeof value === 'object') return value?._id || value?.id || ''
            return value || ''
        },

        romaneioIndisponivel(romaneio = {}) {
            return !!this.getRelationId(romaneio?.fisDocEmiId)
        },

        romaneioItemText(romaneio = {}) {
            const codigo = romaneio?.codigo || romaneio?._id || romaneio?.id || 'Sem código'
            return this.romaneioIndisponivel(romaneio)
                ? `${codigo} - Nota fiscal já emitida`
                : codigo
        },

        alertarRomaneioIndisponivel(romaneio = {}) {
            if (!this.romaneioIndisponivel(romaneio)) return
            this.$notfy.warning(`O romaneio ${romaneio?.codigo || ''} já possui nota fiscal emitida e não pode ser selecionado.`)
        }
    },
    watch: {
        item: {
            async handler(value){
                this.objNf = value
            },
            deep: true,
            immediate: true
        },

        pacelasCads: {
            handler(value) {
                if (Array.isArray(value) && value.length > 0) {
                    this.parcelas = value
                }
            },
            deep: true,
            immediate: false
        },

        objNf: {
            handler(value){
                this.$emit('nf', value)
            },
            deep: true,
            immediate: true
        },

        ['objNf.itens']: {
            async handler(itens){
                const romaneiosSelecionados = this.objNf?.romaneio
                if (!Array.isArray(romaneiosSelecionados) || romaneiosSelecionados.length === 0) {
                    this.arrayItems = []
                    this.osItems = []
                    return
                }

                if (itens?.length > 0) {
                    const response = await Vue.prototype.$http('/Entity/FisPreDocEmiItem/search-fields', {
                        params: {
                            ids: itens.map((item) => item).join(','),
                            sortField: 'sequencia'
                        }
                    })

                    this.arrayItems = response.data.data.data.data
                    this.osItems = response.data.data.data
                } else {
                    this.arrayItems = []
                    this.osItems = []
                }
            },
            deep: true,
            immediate: true
        },

        ['objNf.romaneio']: {
            async handler(romaneio) {

                const romaneiosSelecionados = Array.isArray(romaneio) ? romaneio : []
                const indisponiveis = romaneiosSelecionados.filter((item) => this.romaneioIndisponivel(item))

                if (indisponiveis.length > 0) {
                    indisponiveis.forEach((item) => this.alertarRomaneioIndisponivel(item))
                    this.objNf.romaneio = romaneiosSelecionados.filter((item) => !this.romaneioIndisponivel(item))
                    return
                }

                this.osItems = []
                if (!Array.isArray(romaneio) || romaneio.length === 0) {
                    this.arrayItems = []
                    this.objNf.itens = []
                    this.parcelas = []
                    return
                }

                // restaura parcelas: usa pacelasCads do pai se existir, senão padrão
                if (!this.parcelas || this.parcelas.length === 0) {
                    if (Array.isArray(this.pacelasCads) && this.pacelasCads.length > 0) {
                        this.parcelas = [...this.pacelasCads]
                    } else {
                        this.parcelas = [{ numParcela: '01', vencimento: null, vrlParcela: 0 }]
                    }
                }

                if(romaneio?.length > 0){

                    this.objNf.transportadora = romaneio[0]?.transportadora || this.objNf.transportadora
                    this.objNf.quantidade = romaneio[0]?.quantidade || this.objNf.quantidade
                    this.objNf.numeracao = romaneio[0].numeracao
                    this.objNf.pesoLiquido = romaneio[0].pesoLiquido
                    this.objNf.pesoBruto = romaneio[0].pesoBruto
                    this.objNf.especie = romaneio[0].especie
                    this.objNf.marca = romaneio[0].marca

                    romaneio?.map((item) => {
                        item?.romaneiopackinglist?.map((romaneioPacking) => {
                            romaneioPacking.listaDeEmbarqueItem?.map((listEmbItem) => {
                                // Base do itemJob (mesma origem de ncm/cest usada na Nota de Venda)
                                const itemJobBase = listEmbItem.ordemDeServico[0]?.itemJob[0] || {}
                                const unidadeSiglaBase = listEmbItem.itenListPacking?.[0]?.unidadeSigla
                                    || listEmbItem.itenListPacking?.[0]?.ordemServico?.[0]?.unidadeSigla
                                    || itemJobBase?.unidadeSigla

                                if(!this.isNfRemessa){
                                    this.osItems.push({ ...itemJobBase, unidadeSigla: unidadeSiglaBase })
                                } else {
                                    listEmbItem.itenListPacking?.map((itenListPacking) => {
                                        // Remove id/_id para forçar o mesmo cálculo de ncm/cest/valores feito na Nota de Venda
                                        const { id, _id, ...itenListPackingSemId } = itenListPacking || {}
                                        this.osItems.push({
                                            ...itemJobBase,
                                            ...itenListPackingSemId,
                                            ordemDeServicoItem: listEmbItem.ordemDeServicoItem || itenListPacking?.ordemDeServicoItem,
                                            itemCodigo: itenListPacking?.itemCodigo || itemJobBase?.itemCodigo,
                                            itemCodigoExt: itenListPacking?.itemCodigoExt || itemJobBase?.itemCodigoExt,
                                            unidadeSigla: itenListPacking?.unidadeSigla
                                                || itenListPacking?.ordemServico?.[0]?.unidadeSigla
                                                || unidadeSiglaBase
                                        })
                                    })
                                }
                            })
                        })
                    })
                }

            },
            deep: true,
            immediate: true
        },

        async jobSelected(job) {
            this.objNf.cfop = job.cfopCodigo;
            this.selectedCfop(job.cfopCodigo);
            this.componentKey += 1;
        },

        arrayItems: {
            handler(value){
                this.$emit('itens-nf', value)
            },
            immediate: true,
            deep: true
        },

        async expasionInfoGerais(value){
            // if(value && this.romaneios.length == 0){
            //     this.romaneios = await this.getDataEntity('Romaneio')
            // }
        },

        parcelas: {
            handler(value){
                this.$emit('parcelas', value)
            },
            deep: true
        },

        userInfo: {
            handler(value){
                if(value.cnpj) {
                    this.objNf.cnpj = value?.cnpj
                    this.getCnpjInfo(value?.cnpj)
                }
            },
            deep: true
        },
    },
    async created() {

        this.transportadoras = await this.getDataEntity('Fornecedor')

        await Promise.all([
            //this.getOperacaoFiscalOptions(),
            this.getCFOPs(),
        ]);

    }
}
</script>